import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as O from 'fp-ts/Option';
import * as React from 'react';
import packageJson from '../package.json';
import { useFullMetalUiTheme } from './FullMetalUiThemeContext';
import { RootContext, BrowserProvider } from './Root';
import { headTagThemeBuilder } from './headTagTheme';
const canUseDOM = typeof document !== 'undefined';
export class RunEnv {}
RunEnv.canUseDOM = canUseDOM;
const RootFullHead = /*#__PURE__*/React.memo(({
  headWrapper,
  env
}) => {
  const {
    head,
    tokens
  } = useFullMetalUiTheme();
  const HW = headWrapper;
  const headTagTheme = headTagThemeBuilder(head);
  return _jsxs(HW, {
    children: [_jsx("meta", {
      name: "theme-color",
      content: tokens.colors.primary300
    }), _jsx("meta", {
      name: "msapplication-TileColor",
      content: tokens.colors.primary300
    }), _jsx("meta", {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=5,shrink-to-fit=no"
    }), env !== 'prod' && _jsx("meta", {
      name: "generator",
      content: `FMU@${packageJson.version}`
    }), headTagTheme]
  });
});
export const RootFull = ({
  children,
  env,
  headWrapper
}) => {
  return _jsxs(RootContext.Provider, Object.assign({
    value: {
      env,
      canUseDOM: RunEnv.canUseDOM,
      headWrapper: O.some(headWrapper)
    }
  }, {
    children: [_jsx(RootFullHead, {
      headWrapper: headWrapper,
      env: env
    }), _jsx(BrowserProvider, Object.assign({
      canUseDOM: RunEnv.canUseDOM
    }, {
      children: children
    }))]
  }));
};
RootFull.displayName = 'RootFull';
//# sourceMappingURL=RootFull.js.map